import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/webpractik/web/prod.webpractik.ru.w6p.ru/releases/186/components/features/cases/OldComponents/cases/linkbuilder/index.js");
